import stripHtml from './stripHtml';

/**
 * Returns true if the HTML doesn't have alphanumeric text contents.
 */
export default function isEmptyHtml(html: string): boolean {
    return html.trim() === '' || stripHtml(html).trim() === '';
}
